export const tr = {
    'no-rights': 'Not enough rights to apply the recommendations',
    'platform-accept-button': 'İzin ver',
    'platform-accept-progress-button': 'İzin veriliyor',
    'switch-on-autotargeting-button': 'Aç',
    'switch-on-autotargeting-progress-button': 'Açılıyor'
};
